import React from 'react';
import careerHero from '../../images/career-hero.jpg';
import Header from "../../Header/Header"
import HeroSection from '../../Components/HeroSection/HeroSection';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Footer from '../../Footer/Footer';
import axios from 'axios';
import { Container, Row, Col , Form, Alert} from 'bootstrap-4-react';
class VacancyPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            career: '',
            loading: true,
            careersemail: '',
            careersname: '',
            careersmessage: '',
            resumefile: null,
            resumeloading: false,
            success: ''

        }
        this.handleCareersSubmit = this.handleCareersSubmit.bind(this);
        this.onChange = this.onChange.bind(this)
        this.fileUpload = this.fileUpload.bind(this);
        this.handleCareersTextChange = this.handleCareersTextChange.bind(this);
        this.handleCareersEmailChange = this.handleCareersEmailChange.bind(this);
        this.handleCareersNameChange = this.handleCareersNameChange.bind(this);
        this.handleCareersSubmit = this.handleCareersSubmit.bind(this);
        
    }
    
    componentWillMount() {
        window.scrollTo(0, 0);
        const careerId = this.props.match.params.id;
        axios.get(`moobifunapi/v1/careers/${careerId}`)
        .then(response => {
           this.setState({
               career: response.data.career,
               loading: false
           })
            
        })
        .catch(function (error) {
            console.log(error);
        });
    }
    onChange(e) {
         this.setState({
             resumefile: e.target.files[0]
         })
     }
    fileUpload(file) {
        const url = '/moobifunapi/v1/careers/' + this.props.match.params.id +'/resumes';
        const formData = new FormData();
        formData.append('resumefile', file);
        formData.append('name', this.state.careersname);
        formData.append('email', this.state.careersemail);
        formData.append('message', this.state.careersmessage);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return axios.post(url, formData, config)
    }
     handleCareersNameChange = event => {
         this.setState({
             careersname: event.target.value
         })
     }
     handleCareersEmailChange = event => {
         this.setState({
             careersemail: event.target.value
         })
     }
     handleCareersTextChange = event => {
         this.setState({
             careersmessage: event.target.value
         })
    }
    
    handleCareersSubmit(event) {
        event.preventDefault();
        this.setState({
            resumeloading: true,
        })
        this.fileUpload(this.state.resumefile).then((response) =>  {
            this.setState({
                resumeloading: false,
                success: <Alert success>
                    <i className="fa fa-check"></i>
                    <span>Your CV has been submitted, will get back to you soon!</span>
                </Alert>,
                careersname: '',
                careersemail: '',
                careersmessage: '',
            });
            this.fileInput.value = ''
        })
        .catch(fresponse => {
            this.setState({
                resumeloading: false,
                property: <Alert danger >
                <i className="fa fa-exclamation-triangle"></i>
                <span>An error happened while proccessing your request. Please try again!</span>
            </Alert>
            });
        
        });
    
    }
    render() {
        let loader = 
        <div className="form-loader">
            <i className="fa fa-spinner fa-spin"></i>
        </div>;
        const vacancyInfo = 
            <div className="vacancy-details">
                <Container>
                    <Row>
                        <Col col="md-10" offset="md-1">
                            <h2 className="vacancy-title">{this.state.career.title}</h2>
                            <div className="vacancy-info">
                                <i className="fa fa-map-marker"></i>
                                <span> {this.state.career.location}</span>
                            </div>
                            <div className="vacancy-info">
                                <i className="fa fa-clock-o"></i>
                                <span> {this.state.career.type}</span>
                            </div>
                            {/* <div className="vacancy-info">
                                <i className="fa fa-calendar"></i>
                                <span>MRCH 2019</span>
                            </div> */}

                            <div className="vacancy-description">
                                <p>
                                    {this.state.career.longDescription}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
       return (
        <div className="vacancy-page">
            <Header />
            <HeroSection background={careerHero} />
            <section className="page-content">
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/carees/" className="current">Careers </Link></li>
                    </ul>
                </Container>
                <div className="careers">
                    <h2 className="second-title"><i className="fa fa-circle"></i> <span>Join Our Team </span><i className="fa fa-circle"></i></h2>
                    {this.state.loading ? <i className="fa fa-spinner spin"></i> : vacancyInfo }
                </div>
            </section>
            <div className="careers-form">
                    <Container>
                        <Row className="row-center">
                            <Col col="md-8 12">
                                <h2>Apply</h2>
                                <Form onSubmit={this.handleCareersSubmit} >
                                    <Form.Group>
                                        <label htmlFor="name">Full Name</label>
                                        <Form.Input type="text" id="name" required autocomplete="off" value={this.state.careersname}   onChange={this.handleCareersNameChange} />
                                    </Form.Group>
                                    
                                    <Form.Group>
                                        <label htmlFor="email">Email address</label>
                                        <Form.Input type="email" required id="email" autocomplete="off" value={this.state.careersemail}  onChange={this.handleCareersEmailChange} />
                                    </Form.Group>
                                    <Form.Group>
                                        <label htmlFor="resume">Resume</label>
                                        <div className="file-upload">
                                           <input type="file" required id="resume" onChange={this.onChange}  ref={ref=> this.fileInput = ref} />
                                        </div>
                                    </Form.Group>
                                    <Form.Group>
                                        <label htmlFor="message">Message</label>
                                        <Form.Textarea id="message" rows="3" required autocomplete="off" value={this.state.careersmessage}  onChange={this.handleCareersTextChange}></Form.Textarea>
                                    </Form.Group>
                                     {this.state.resumeloading ? loader : ""}
                                    <button className="main-btn" primary type="submit">Send</button>
                                </Form>
                                {this.state.success}
                            </Col>
                        </Row>
                    </Container>
                </div>
            <Footer/>
        </div>
       );
    }
}
export default VacancyPage;
